module.exports = __webpack_public_path__ + "static/media/glitter.f244097d.mp3";